'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	fields: {
		paddingBottom: '20px'
	},

	actions: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '20px'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingForm/styles/index.js